// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__t2T7K","opaque":"header_opaque__QVxmi","textBlack":"header_textBlack__JBrhR","overlay":"header_overlay__DTkCv","is-active":"header_is-active__ZL_R3"};